<template>
  <v-combobox multiple v-model="emails" label="Agregar emails" append-icon chips deletable-chips
              @keyup.space="updateEmails" :search-input.sync="searchEmail" prepend-icon="mail_outline"
              :errorMessages="emailErrors" no-data-text="No hay datos disponibles" :disabled="disabled">
  </v-combobox>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      emails: [],
      searchEmail: '',
      emailErrors: []
    }
  },

  methods: {
    updateEmails () {
      if (!this.searchEmail) return
      this.searchEmail = this.searchEmail.substr(0, this.searchEmail.indexOf(' '))
      if (this.emails.indexOf(this.searchEmail) === -1) {
        this.emails.push(this.searchEmail)
      }
      this.searchEmail = ''
    },
    validateEmails () {
      this.emailErrors = []
      let errors = ''
      for (let email of this.emails) {
        if (!this.isValidEmail(email)) {
          errors += `${email}, `
        }
      }
      if (errors.length) {
        this.emailErrors.push(`Emails inválidos: ${errors.slice(0, -2)}`)
      }
    },
    isValid () {
      return this.emailErrors.length === 0
    },
    isValidEmail (email) {
      let re = /\S+@\S+\.\S+/
      return re.test(String(email).toLowerCase())
    },
    getEmails () {
      return this.emails
    }
  }
}
</script>
